//页面全局功能控制信息
var pageObject={
    //当前页面下拉刷新的启用状态
    pullToRefresh:true,
    //当前页面下拉刷新的实例
    pullToRefreshPtr:null
}
/**
 * 获取页面下拉刷新是否启用状态
 */
function getPullToRefreshStatus(){
    return this.pageObject.pullToRefresh;
}
/**
 * 停止页面下拉刷新
 * @param {*} object 
 */
function stopPullToRefresh(){
    this.pageObject.pullToRefresh = false;
}
/**
 * 启用页面下拉刷新
 * @param {*} object 
 */
function startPullToRefresh(ptr){
    this.pageObject.pullToRefresh = true;
    if(ptr){
        this.pageObject.pullToRefreshPtr = ptr;
    }
}
/**
 * 获取页面下拉刷新ptr实例
 */
function getPullToRefreshPtr(){
    return this.pageObject.pullToRefreshPtr;
}
/**
 * 用于改变页面用户定制化状态
 * @param {
 * routerId:"路由ID",
 * status: true 进入编辑状态   false  退出编辑状态,
 * save: true 且 status的参数为 false 的时候则是需要保存状态,其他情况则是不执行保存状态
 * } ctx 
 */
function changePageUserDefinedStatus(ctx){
   return window.IdmBuiltin_changePageUserDefinedStatus(ctx);
}
/**
 * 执行用户自定义保存事件
 * @param {routerId:"路由ID"} ctx 
 * @returns 
 */
function executeUserDefinedSave(ctx){
    return window.IdmBuiltin_executeUserDefinedEvent(ctx,"save");
}
/**
 * 执行用户自定义重置事件
 * @param {routerId:"路由ID"} ctx 
 * @returns 
 */
function executeUserDefinedReset(ctx){
    return window.IdmBuiltin_executeUserDefinedEvent(ctx,"reset");
}
/**
 * 执行用户自定义退出事件
 * @param {routerId:"路由ID"} ctx 
 * @returns 
 */
function executeUserDefinedQuit(ctx){
    return window.IdmBuiltin_executeUserDefinedEvent(ctx,"quit");
}
/**
 * 用户自定义的时候移动组件的索引位置事件
 * @param {routerId:"路由ID",pageid:"页面ID",moveIndex:"要移动组件的索引位置",targetIndex:"移动到的索引位置"} ctx 
 * @returns 
 */
function executeComponentMoveIndex(ctx){
    return window.IdmBuiltin_executeComponentMoveIndexEvent(ctx);
}

/**
 * 检查组件是否有权限
 * @param {*} item 
 */
function checkComponentHasAuthority(item){
    let showComponent = true;
    //此处要判断一下openAuthorize&&privilege&&role&&dept&&user
    let attrConfig = IDM.setting.applications.basicAttributeAuthorizeConfig;
    let openAuthorize = attrConfig.openAuthorize;
    if(item.props&&item.props.basicAttr&&item.props.basicAttr.showType=="show"||(item.againLoad===true&&item.props&&item.props.basicAttr&&item.props.basicAttr.showType!="role")){
    //   console.log("🚀 ~ file: Page.vue ~ line 1888 ~ moduleData.forEach ~ item.againLoad", item.againLoad)
      //这里就是直接显示，不做处理
      
    }else if(item.props&&item.props.basicAttr&&item.props.basicAttr.showType=="hide"){
      showComponent = false;
    }else if(item.props&&item.props.basicAttr&&item.props.basicAttr.showType=="custom"&&item.props.basicAttr.customShowEvent){
      //自定义显示
      const customArray = IDM.invokeCustomFunctions.apply(this, [item.props.basicAttr.customShowEvent, {}]);
      if(customArray&&customArray.length){
        showComponent = customArray[0];
      }
    }else if(openAuthorize===true){
      let privilege = attrConfig.privilege||{},privilegePass=-1,
      role = attrConfig.role||{},rolePass = -1,
      dept = attrConfig.dept||{},deptPass = -1,
      user = attrConfig.user||{},userPass = -1;
      //比对权限
      if(privilege.open===true&&privilege.comparisonObject&&item.props&&item.props.basicAttr&&item.props.basicAttr.privilegeList&&item.props.basicAttr.privilegeList.length){
        let privilegeComparisonObject = IDM.express.replace("@["+privilege.comparisonObject+"]",{IDM:IDM,window});//,...this.pageInterfaceResultObject
        if(privilege.separator&&IDM.type(privilegeComparisonObject)!='array'){
          privilegeComparisonObject = privilegeComparisonObject.split(privilege.separator);
        }
        //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
        privilegePass = false;
        //直接用选择的权限去判断
        item.props.basicAttr.privilegeList.forEach(iitem=>{
          let comparisonKey = IDM.express.replace("@["+(privilege.comparisonKey||'key')+"]",iitem);
          if(privilegeComparisonObject===undefined||privilegeComparisonObject.indexOf(comparisonKey)>-1){
            privilegePass = true;
          }
        })
      }
      //比对角色
      if(role.open===true&&role.comparisonObject&&item.props&&item.props.basicAttr&&item.props.basicAttr.roleList&&item.props.basicAttr.roleList.length){
        let roleComparisonObject = IDM.express.replace("@["+role.comparisonObject+"]",{IDM:IDM,window});//,...this.pageInterfaceResultObject
        if(role.separator&&IDM.type(roleComparisonObject)!='array'){
          roleComparisonObject = roleComparisonObject.split(role.separator);
        }
        //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
        rolePass = false;
        //直接用选择的权限去判断
        item.props.basicAttr.roleList.forEach(iitem=>{
          let comparisonKey = IDM.express.replace("@["+(role.comparisonKey||'key')+"]",iitem);
          if(roleComparisonObject===undefined||roleComparisonObject.indexOf(comparisonKey)>-1){
            rolePass = true;
          }
        })
      }
      //比对部门
      if(dept.open===true&&dept.comparisonObject&&item.props&&item.props.basicAttr&&item.props.basicAttr.deptList&&item.props.basicAttr.deptList.length){
        let deptComparisonObject = IDM.express.replace("@["+dept.comparisonObject+"]",{IDM:IDM,window});//,...this.pageInterfaceResultObject
        if(dept.separator&&IDM.type(deptComparisonObject)!='array'){
          deptComparisonObject = deptComparisonObject.split(dept.separator);
        }
        //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
        deptPass = false;
        //直接用选择的权限去判断
        item.props.basicAttr.deptList.forEach(iitem=>{
          let comparisonKey = IDM.express.replace("@["+(dept.comparisonKey||'key')+"]",iitem);
          if(deptComparisonObject===undefined||deptComparisonObject.indexOf(comparisonKey)>-1){
            deptPass = true;
          }
        })
      }
      //对比部门集合（包含贯穿下级的）
      if(dept.open===true&&dept.comparisonObject&&item.props&&item.props.basicAttr&&item.props.basicAttr.deptColumns&&item.props.basicAttr.deptColumns.length){
        let deptComparisonObject = IDM.express.replace("@["+dept.comparisonObject+"]",{IDM:IDM,window});//,...this.pageInterfaceResultObject
        if(dept.separator&&IDM.type(deptComparisonObject)!='array'){
          deptComparisonObject = deptComparisonObject.split(dept.separator);
        }
        //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
        deptPass = false;
        if(deptComparisonObject===undefined){
          deptPass = true;
        }else{
          //直接用选择的权限去判断
          item.props.basicAttr.deptColumns.forEach(iitem=>{
            //对比，如果不包含下级则只对比最后一个，如果包含下级则只要对比出来了则算通过
            let deptList = iitem.deptList,includeChild=iitem.includeChild;
            deptList&&deptList.forEach(deptItem=>{
              let comparisonKey = IDM.express.replace("@["+(dept.comparisonKey||'key')+"]",deptItem);
              if((includeChild=="0"&&IDM.type(deptComparisonObject)=="array"&&deptComparisonObject[deptComparisonObject.length-1]==comparisonKey)||
              (includeChild=="1"&&deptComparisonObject.indexOf(comparisonKey)>-1)
              ){
                deptPass = true;
              }
            })
          })
        }
      }
      //比对用户
      if(user.open===true&&user.comparisonObject&&item.props&&item.props.basicAttr&&item.props.basicAttr.userList&&item.props.basicAttr.userList.length){
        let userComparisonObject = IDM.express.replace("@["+user.comparisonObject+"]",{IDM:IDM,window});//,...this.pageInterfaceResultObject
        //选择了还没比对要设置为false不通过，下面有交集了再设置为true通过
        userPass = false;
        //直接用选择的权限去判断
        let userArray = item.props.basicAttr.userList.map(item=>{
          let comparisonKey = IDM.express.replace("@["+(user.comparisonKey||'key')+"]",item);
          return comparisonKey
        });
        if(userArray.indexOf(userComparisonObject)>-1){
          userPass = true;
        }
      }
      //如果不为空则需要判断是否通过
      if(!((privilegePass===-1&&rolePass===-1&&deptPass===-1&&userPass===-1)||(privilegePass!==-1&&privilegePass)||(rolePass!==-1&&rolePass)||(deptPass!==-1&&deptPass)||(userPass!==-1&&userPass))){
        showComponent = false;
      }
    }
    return showComponent;
}

export default {
    getPullToRefreshStatus,
    getPullToRefreshPtr,
    stopPullToRefresh,
    startPullToRefresh,
    pageObject:pageObject,
    changePageUserDefinedStatus,
    executeUserDefinedSave,
    executeUserDefinedReset,
    executeUserDefinedQuit,
    checkComponentHasAuthority,
    executeComponentMoveIndex
}